import React from 'react';
import { connect } from 'react-redux';
import get from 'lodash.get';
import renderNothing from 'recompose/renderNothing';
import branch from 'recompose/branch';
import compose from 'recompose/compose';
import SITE_MODES from '../../../constants/site-modes';
import USER_TYPES from '../../../constants/user-types';
import PersonalityIcon from '../Icons/Personality';
import Notification from '../Notification';
import NOTIFICATIONS from '../../../constants/notifications';

const NewPersonalityAssessmentModal = () => (<Notification
    type={NOTIFICATIONS.NEW_PERSONALITY}
    icon={PersonalityIcon}
    title="Learn More about Your Personality"
    text="We released a brand-new Personality Assessment! Take the new assessment to learn more about how you tend to think, feel, and interact with others."
    button="Take New Assesment"
    to="/assessment/personality"
    close
/>);

const isOpen = ({ auth, me, theme, users }) => {
    if (auth.level !== USER_TYPES.USER) {
        return false;
    }
    if (!me) {
        return false;
    }
    if (theme.siteMode !== SITE_MODES.EDUCATION) {
        return false;
    }

    const scores = get(users, `list.${me.userId}.scores`);

    return !!scores && scores.personality && Object.keys(scores.personality).length === 5;
};

export default compose(
    connect(state => ({
        open: isOpen(state),
    })),
    branch(({ open }) => !open, renderNothing),
)(NewPersonalityAssessmentModal);



// WEBPACK FOOTER //
// ./src/client/Components/NewPersonalityAssessmentModal/NewPersonalityAssessmentModal.js